import { Form, Formik, FormikHelpers } from "formik";
import { useNavigate } from "react-router-dom";
import { TestSeriesFormValues } from "src/models/TestSeries.model";
import { showToast } from "src/utils/showToaster";
import { array, object, string } from "yup";
import TestSeriesForm from "../Layout/TestSeriesForm";
import { useAddTestSeriesMutation } from "src/services/TestSeriesServices";


const AddTestSeriesFormWrapper = () => {
  const navigate = useNavigate()
  const [addTestQuestion] = useAddTestSeriesMutation();

  // Form Initial Values
  const initialValues: TestSeriesFormValues = {
    testImage: '',
    testDescription: '',
    questionTag: [],
    questionTechnologyId: [],
    questionTitle: "",
    questionOptions: [],
    price: '',
    oldPrice: '',
    passingPercent: '',
    testTime: ''
  };

  // Validation Schema
  const validationSchema = object().shape({
    questionTag: array().min(1, "At least one tag is required"),
    questionTechnologyId: array().min(1, "At least one technology is required"),
    questionTitle: string().required("Title is required"),
    testDescription: string().required("Description is required"),
    testImage: string().required("Image is required"),
    questionOptions: array().min(1, "At least one qustion is select"),
    // price: string().required("Price is required"),
    passingPercent: string().required("Passing percent is required"),
    testTime: string().required("Test Time is required"),
    price: string().required("offer price is required")
      .test(
        'is-greater-or-equal',
        'Offer Price should not be greater than MRP',
        function (value: any) {
          const { oldPrice } = this.parent;
          return value <= Number(oldPrice);
        }
      ),
  });

  // Handle Submit
  const handleSubmit = (
    values: TestSeriesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<TestSeriesFormValues>
  ) => {
    const formatedValue = {
      testTag: values?.questionTag,
      testTechnologyId: values?.questionTechnologyId?.map((technology: any) => technology?.value),
      testTitle: values?.questionTitle,
      questionId: values?.questionOptions?.map((question: any) => question?._id) || [],
      testImage: values?.testImage,
      testDescription: values?.testDescription,
      price: values?.price,
      mrp: values?.oldPrice,
      passingPercent: values?.passingPercent,
      testTime: values?.testTime,
    };
    addTestQuestion(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          navigate('/test-module/test-series')
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className="h-full overflow-hidden contents">
          <TestSeriesForm
            formikProps={formikProps}
            formType="Add"
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddTestSeriesFormWrapper;
